import { z } from "zod";

export const helpDocsTemplateItemSchema = z.object({
    templateId: z.number().nullable().nullish(),
    helpDocId: z.number(),
    order: z.number(),
});

export type HelpDocTemplateItem = z.infer<typeof helpDocsTemplateItemSchema>;
